import RecommendedProduct from './recommended-product';

export default RecommendedProduct;
